import { createContext } from 'react';
import CmsHotelService from '../Services/CmsHotelService';

const CmsHotelContext = createContext<CmsHotelService>(new CmsHotelService());

export default CmsHotelContext;
